export default "__VITE_ASSET__22779035__"